import React from 'react';
import EducatorsWhoCreatedProject from './EducatorsWhoCreatedProject';
import EducatorsAffiliatedWithNetworkSite from './EducatorsAffiliatedWithNetworkSite';
import EducatorsWithOpenProject from './EducatorsWithOpenProject';

export default function EducatorsWithOpenProjectGroup(props) {
  return (
    <>
      <EducatorsWithOpenProject {...props} />
      <EducatorsWhoCreatedProject {...props} />
      <EducatorsAffiliatedWithNetworkSite {...props} />
    </>
  )
}
